@import (reference) '../../../constants/spacing.module.less';

.drop-down-menu-button {
  border-radius: 0 3px 3px 0;
  padding: @space-0;
}

.dropdown-menu {
  max-width: none;
}
